var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrochuresIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9984 34.3525C39.9185 34.3525 38.0478 35.2275 36.7195 36.624L21.1997 29.0255C21.253 28.6685 21.2898 28.3072 21.2898 27.9353C21.2898 27.573 21.2548 27.2195 21.204 26.8722L36.7012 19.3568C38.0303 20.7647 39.9098 21.6484 41.9984 21.6484C46.0252 21.6484 49.2898 18.3838 49.2898 14.357C49.2898 10.3294 46.0252 7.06567 41.9984 7.06567C37.9717 7.06567 34.707 10.3294 34.707 14.357C34.707 14.7193 34.742 15.0719 34.7928 15.4202L19.2957 22.9355C17.9665 21.5277 16.0879 20.6439 13.9984 20.6439C9.97078 20.6439 6.70703 23.9085 6.70703 27.9353C6.70703 31.9629 9.97078 35.2267 13.9984 35.2267C16.0783 35.2267 17.949 34.3517 19.2773 32.9552L34.7972 40.5537C34.7438 40.9098 34.707 41.272 34.707 41.6439C34.707 45.6715 37.9717 48.9353 41.9984 48.9353C46.0252 48.9353 49.2898 45.6715 49.2898 41.6439C49.2898 37.6163 46.0252 34.3525 41.9984 34.3525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrochuresIcon);
export default __webpack_public_path__ + "static/media/brochuresIcon.ea28e1bd68ce6ec804d4440822fbb3b9.svg";
export { ForwardRef as ReactComponent };